import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { getPlanNameData } from 'utils/PlanName';

const PlanName = (props) => {
    const customPlanNameData = useMemo(() => getPlanNameData(props.planId), [props]);

    return customPlanNameData ? (
        <FormattedMessage id={customPlanNameData.id} values={{ duration: customPlanNameData.duration }} />
    ) : (
        props.planTitle
    );
};

PlanName.propTypes = {
    planId: PropTypes.number.isRequired,
    planTitle: PropTypes.string.isRequired,
};

export default PlanName;
